<!--
  Generated template for the TextImpressPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
	<ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title>
        <!-- <div style="padding-top:15px;padding-bottom:15px;"> -->
          {{ 'SETTINGS_IMPRESSUM_BTN' | translate}}
		<!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content padding>
	<!-- <h2>Impressum</h2> -->

	<p>
		<b>Anbieterkennzeichnung gem. &#167;
			TDG, verantwortlich:</b> <br /> (IT)&#x000B2; interactive GmbH,
		Joseph-von-Fraunhofer Str. 20, Technologiezentrum, 44227 Dortmund
		<br /> vertretungsberechtigter Geschäftsführer: Dipl. Inform. Klaus
		Lewerenz
		<br /> E-Mail: info@it2in.de
		<br /> Tel: 0231/ 97 00 382
		<br /> Registergericht: Amtsgericht Frankfurt am Main
		<br /> Register-Nr.: HRB 103054
		<br /> Inhaltlich Verantwortlicher nach § 55 Abs. 2 RSTV: Klaus Lewerenz
	</p>
	<p>
		<b>Rechtliche Hinweise, Qualitätssicherung, Haftungsausschluss</b> <br /> Diese
		Website wurde mit höchster Sorgfalt zusammengestellt. Für die
		Fehlerfreiheit und Genauigkeit der enthaltenen Informationen
		übernimmt (IT)&#x000B2; interactive GmbH, nachfolgend (IT)&#x000B2; interactive GmbH genannt,
		dennoch keine Gewähr. Alle Inhalte des
		spooorts Portals werden Ihnen ohne Haftung seitens
		des Herausgebers (IT)&#x000B2; interactive GmbH zur Verfügung
		gestellt.(IT)&#x000B2; interactive GmbH behält sich das Recht auf Änderungen
		oder Ergänzungen der bereitgestellten Informationen vor. Jegliche
		Haftung für Schäden, die direkt oder indirekt aus der Benutzung
		dieser Website entstehen, ist ausgeschlossen, soweit diese nicht
		auf Vorsatz oder grober Fahrlässigkeit beruhen. Trotz sorgfältiger
		inhaltlicher Kontrolle übernimmt (IT)&#x000B2; interactive GmbH keine
		Haftung für die Inhalte externer Links. Für den Inhalt der
		verlinkten Seiten sind ausschließlich deren Herausgeber
		verantwortlich. Der Inhalt des spooorts Portals ist
		urheberrechtlich geschützt. 
	</p>
</ion-content>